export default __webpack_public_path__ + "static/media/yellow_option.abadb401.svg";